<div class="item" *ngIf="user" [class.disabled]="isDisabled">
  <div class="info-wrapper">
    <div *ngIf="!user.avatar" class="user-name-initials mr-2">
      <span class="title-sm inner">{{ user.firstName?.charAt(0) }}{{ user.lastName?.charAt(0) }}</span>
    </div>
    <div *ngIf="user.avatar" class="user-avatar mr-2" [ngStyle]="{ 'background-image': 'url(' + user.avatarUrl + ')' }"></div>
    <div class="flex flex-col">
      <div class="flex items-center name-label-container">
        <span class="label-sm user-name">{{ user.firstName }} {{ user.lastName }}</span>
        <ng-container *ngIf="chipsLabel?.text">
          <ui2-label
            class="ml-1"
            [text]="chipsLabel.text"
            [bgColor]="chipsLabel?.bgColor || DEFAULT_LABEL_BG_COLOR"
            [labelColor]="chipsLabel?.textColor || DEFAULT_LABEL_COLOR"
          >
          </ui2-label>
        </ng-container>
      </div>
      <span *ngIf="!hideEmail" class="label-xs user-email">{{ user.email }}</span>
    </div>
  </div>

  <span *ngIf="!hideCloseIcon" class="close-icon icon2-x16-close-m" (click)="onCloseClicked(user)"></span>
</div>
